import "bootstrap/dist/css/bootstrap.min.css";
import es from "date-fns/locale/es";
import React from "react";
import { registerLocale } from "react-datepicker";
import { Route, BrowserRouter as Router, Switch } from "react-router-dom";
import {
  UserContextConsumer,
  UserContextProvider,
} from "./backend/userContext";
import history from "./history";
import routes from "./routes";
import "./shards-dashboard/styles/shards-dashboards.1.1.0.css";
import "./assets/app.css";
// Highlight is a tool that helps you monitor and debug your web applications.
import { H } from "highlight.run";
import { HIGHLIGHT_PROJECT_ID } from "./utils/constants";

registerLocale("es", es);

const env = process.env.NODE_ENV;
if (env === "production") {
  H.init(HIGHLIGHT_PROJECT_ID, {
    serviceName: "frontend-app",
    recordCrossOriginIframe: true,
    tracingOrigins: true,
    networkRecording: {
      enabled: true,
      recordHeadersAndBody: true,
      urlBlocklist: [
        // insert full or partial urls that you don't want to record here
        // Out of the box, Highlight will not record these URLs (they can be safely removed):
        "https://www.googleapis.com/identitytoolkit",
        "https://securetoken.googleapis.com",
      ],
    },
  });
}

export default () => {
  return (
    <Router basename={""}>
      <UserContextProvider>
        <UserContextConsumer>
          {(user) => (
            <Switch>
              {routes().map((route, index) => {
                return (
                  <Route
                    key={index}
                    path={route.path}
                    exact={route.exact}
                    history={history}
                    component={(props) => {
                      return (
                        <route.layout {...props}>
                          <route.component {...props} user={user} />
                        </route.layout>
                      );
                    }}
                  />
                );
              })}
            </Switch>
          )}
        </UserContextConsumer>
      </UserContextProvider>
    </Router>
  );
};
